<bevvi-bot-chat-card
  [type]="type.CONFIRMATION"
  [title]="payload().question"
  [description]="payload().action_summary || ''"
  [primaryButtonText]="primaryOption()?.label || 'Yes'"
  [secondaryButtonText]="secondaryOption()?.label || 'No'"
  [showActions]="true"
  [disabled]="disabled()"
  (submitClick)="onPrimaryClick()"
  (secondaryClick)="onSecondaryClick()"
/>
